export enum ETipoVinculo {
  PARCEIRO_DO_TITULAR_DA_PLG = 'Parceiro do titular da PLG',
  MEMBRO_DA_CADEIA_PRODUTIVA = 'Membro da cadeia produtiva',
  COOPERADO = 'Cooperado',
  MANDATARIO = 'Mandatário',
}

interface TipoVinculoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const TipoVinculoDetalhe: { [key in ETipoVinculo]: TipoVinculoInfo } = {
  [ETipoVinculo.PARCEIRO_DO_TITULAR_DA_PLG]: {
    nome: 'PARCEIRO_DO_TITULAR_DA_PLG',
    indice: 0,
    label: 'Parceiro do titular da PLG',
  },
  [ETipoVinculo.MEMBRO_DA_CADEIA_PRODUTIVA]: {
    nome: 'MEMBRO_DA_CADEIA_PRODUTIVA',
    indice: 1,
    label: 'Membro da cadeia produtiva',
  },
  [ETipoVinculo.COOPERADO]: {
    nome: 'COOPERADO',
    indice: 2,
    label: 'Cooperado',
  },
  [ETipoVinculo.MANDATARIO]: {
    nome: 'MANDATARIO',
    indice: 3,
    label: 'Mandatário',
  },
};

export function getValueFromETipoVinculoByIndex(index: number) {
  const labels = Object.values(ETipoVinculo);
  return labels[index];
}

export enum ETransportador {
  PROPRIO_TITULAR_DA_PLG = 'Próprio titular da PLG',
  PARCEIRO_DO_TITULAR_DA_PLG = 'Parceiro do titular da PLG',
  MEMBRO_DA_CADEIA_PRODUTIVA = 'Membro da cadeia produtiva',
  COOPERADO = 'Cooperado',
  TERCEIROS = 'Terceiros',
}

export function getValueFromETransportadorByIndex(index: number) {
  const labels = Object.values(ETransportador);
  return labels[index];
}

export enum EDocumentoVinculado {
  NOTA_FISCAL = 'Nota fiscal',
  RECIBO = 'Recibo',
  CONTRATO = 'Contrato',
  COPIA_DO_TITULO_PLG = 'Cópia do título (PLG)',
  AUTORIZACAO_DE_TRANSPORTE = 'Autorização de transporte',
  OUTROS = 'Outros',
}

interface DocumentoVinculadoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const DocumentoVinculadoDetalhe: {
  [key in EDocumentoVinculado]: DocumentoVinculadoInfo;
} = {
  [EDocumentoVinculado.NOTA_FISCAL]: {
    nome: 'NOTA_FISCAL',
    indice: 0,
    label: EDocumentoVinculado.NOTA_FISCAL,
  },
  [EDocumentoVinculado.RECIBO]: {
    nome: 'RECIBO',
    indice: 1,
    label: EDocumentoVinculado.RECIBO,
  },
  [EDocumentoVinculado.CONTRATO]: {
    nome: 'CONTRATO',
    indice: 2,
    label: 'Contrato',
  },
  [EDocumentoVinculado.COPIA_DO_TITULO_PLG]: {
    nome: 'COPIA_DO_TITULO_PLG',
    indice: 3,
    label: 'Cópia do título',
  },
  [EDocumentoVinculado.AUTORIZACAO_DE_TRANSPORTE]: {
    nome: 'AUTORIZACAO_DE_TRANSPORTE',
    indice: 4,
    label: EDocumentoVinculado.AUTORIZACAO_DE_TRANSPORTE,
  },
  [EDocumentoVinculado.OUTROS]: {
    nome: 'OUTROS',
    indice: 5,
    label: EDocumentoVinculado.OUTROS,
  },
};
